/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/admin/dashboard',
    name: 'Dashboard',
    slug: "dashboard",
    icon: 'HomeIcon',
    i18n: 'Dashboard',
		roles: ['admin', 'admin_observer']
    // submenu: [
    //   {
    //     url: '/admin/dashboard',
    //     name: 'Analytics',
    //     slug: 'dashboard-analytics',
    //     i18n: 'Analytics'
    //   }
    // ]
  },

  {
    header: 'Events',
    icon: 'PackageIcon',
    i18n: 'Events',
    items: [
      {
        url: "/admin/event/new",
        name: "New Event",
        slug: "new-event",
        icon: 'CreditCardIcon',
        i18n: 'NewEvent'
      },
      {
        url: '/admin/event/past',
        name: 'Past Events',
        slug: 'past-events',
        icon: 'CheckSquareIcon',
        i18n: 'PastEvents',
				roles: ['admin', 'admin_observer']
      },
      {
        url: '/admin/quorum/list',
        name: 'Quorum',
        slug: "quorum",
        icon: 'BookIcon',
        i18n: 'Quorum'
      },
    ]
  },
  {
    header: 'Users',
    icon: 'UserIcon',
    i18n: 'User',
    items: [
      {
        url: '/admin/user/list',
        name: 'User List',
        slug: 'list',
        icon: 'ListIcon',
        i18n: 'List',
				roles: ['admin', 'admin_observer']
      }
    ]
  },
  {
    header: 'Campaign',
    icon: 'campaign',
    i18n: 'Campaign',
    items: [
      {
        url: '/admin/campaign',
        name: 'Campiagn',
        slug: 'campaign',
        icon: 'ListIcon',
        i18n: 'List',
				roles: ['admin', 'admin_observer']
      }
    ]
  },
  {
    header: 'Tracking Logs',
    icon: 'UserIcon',
    i18n: 'TrackLogs',
    items: [
      {
        url: '/admin/tracking-logs',
        name: 'TrackLogs',
        slug: 'list',
        icon: 'ListIcon',
        i18n: 'List',
				roles: ['admin']
      }
    ]
  },
  {
    header: 'Settings',
    icon: 'icon-settings',
    i18n: 'Settings',
    items: [
      {
        url: '/admin/event/globalsettings',
        name: 'SMS Email Settings',
        slug: 'SMSEmailSettings',
        icon: 'MailIcon',
        i18n: 'SMSEmailSettings'
      },
      {
        url: '/admin/designsettings',
        name: 'Design Configuration Settings',
        slug: 'DesignSettings',
        icon: 'SettingsIcon',
        i18n: 'DesignSettings'
      },
      // {
      //   url: '/admin/create',
      //   name: 'Create Admin',
      //   slug: 'CreateAdmin',
      //   icon: 'PlusCircleIcon',
      //   i18n: 'CreateAdmin'
			// }, 
			{
				url: '/admin/privacy-policy',
				name: 'Privacy Policy',
				slug: 'PrivacyPolicy',
				icon: 'ShieldIcon',
				i18n: 'PrivacyPolicy'
			},
    ]
  },
  {
    url: '/admin/language',
    name: 'Language',
    slug: "language",
    icon: 'GlobeIcon',
    i18n: 'Language',
		roles: ['admin']
    // submenu: [
    //   {
    //     url: '/admin/dashboard',
    //     name: 'Analytics',
    //     slug: 'dashboard-analytics',
    //     i18n: 'Analytics'
    //   }
    // ]
  },
  // {
  //   header: 'Settings',
  //   icon: 'icon-settings',
  //   i18n: 'Settings',
  //   items: [
  //     {
  //       url: '/admin/designsettings',
  //       name: 'Design Configuration Settings',
  //       slug: 'DesignSettings',
  //       icon: 'SettingsIcon',
  //       i18n: 'DesignSettings'
  //     },
  //   ]
  // },
]
